module.exports = __webpack_public_path__ + "img/btn_xiankuang_ov.1f12c12b.png";